import React from 'react';

type HighlightTextContextType = {
  searchWords: string[];
};

const HighlightTextContext = React.createContext<HighlightTextContextType>({ searchWords: [] });

export default HighlightTextContext;
